<template>
  <div>
    <modals-container name="modal" />
    <div v-if="lists && lists.length > 0">
      <el-table
        :data="lists" stripe border
        style="width: 100%">
        <el-table-column
          label="年份" prop="year" width="120" sortable>
        </el-table-column>
        <el-table-column
          prop="learnCount" label="完成课程数" width="180" sortable>
        </el-table-column>
        <el-table-column
          prop="learnHour" label="获得学时" width="180" sortable>
          <template slot-scope="p">
            <span v-if="p.row.year == 2018 && p.row.learnHour > 21">21</span>
            <span v-else>{{p.row.learnHour}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="p">
            <el-button size="mini" type="primary" @click="getCert(p.row)">打印证书</el-button>
            <el-button v-if="p.row.year != 2018" size="mini" type="primary" @click="getStats(p.row)">课程明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <h5 class="none_ts" v-if="lists.length == '0'">
      <img src="@/assets/images/none_data.jpg" alt="">
    </h5>
    <!--<div class="zy_list_bottom">
      <dl>
        <dt v-if="lists.length > 0">共{{cnt}}条记录</dt>
        <dd v-if="lists.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>-->
  </div>
</template>
<script>
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import ModalBox from '@/components/common/modal/index.vue'
  import InfoBox from '@/components/byl/iframeBox/index.vue'
  import config from '@/config'
  import api from '@/api'
  import { getCookie } from '@/store/cookies.js'
  import { mapState, mapActions } from 'vuex'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        pages: 0,
        cnt: 0,
        filters: {
          pageNo: 1,
          pageSize: 9,
          delFlag: '0',
          inBatchNo: '1'
        },
        records: {}
      }
    },
    created () {
      this.getLists().then((r) => {
        if (r.data) {
          this.lists = r.data
        } else {
          this.lists = []
        }
      })
    },
    methods: {
      ...mapActions('auth', {
        hasMemberByUserId: 'hasMemberByUserId'
      }),
      invoiceDateFormat: utils.invoiceDateFormat,
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.getLists(this.filters)
      },
      getStats (item) {
        let userid = getCookie(process.env.USERID_KEY)
        let href = config.fineReportPath + '?reportlet=%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%2F%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%5B8bfe%5D%5B7a0b%5D%5B5b66%5D%5B4e60%5D%5B8be6%5D%5B60c5%5D.cpt&' + 'year=' + item.year + '&userId=' + userid
        this.showIframeBox({title: '课程明细', href: href})
      },
      getLists () {
        return new Promise((resolve, reject) => {
          this.$api.post(this.$global.courseApiPath, '/course/learn/count/years', null, r => {
            resolve(r)
          })
        })
      },
      getCert (item) { // 获取证书
        this.hasMemberByUserId(getCookie(process.env.USERID_KEY)).then((r) => {
          if (!r) {
            this.$toasted.show('您没有填写个人资料, 请前往个人中心完善资料')
          } else {
            let userid = getCookie(process.env.USERID_KEY)
            let href = config.fineReportPath + '?reportlet=%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%2F%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%5B8bfe%5D%5B7a0b%5D%5B8bc1%5D%5B4e66%5D%5B6253%5D%5B5370%5D.cpt&userId=' + userid + '&year=' + item.year
            this.showIframeBox({title: '打印证书', href: href})
          }
        })
      },
      showIframeBox (o) {
        var that = this
        var _open = function (inputs) {
          that.$modal.show(ModalBox, {
            opts: {
              title: o.title,
              styles: {
                width: String(0.9 * window.screen.availWidth),
                height: String(0.9 * window.screen.availHeight)
              },
              offEdit: true, // 是否包含"确定"与"取消"按钮
              yesTxt: '打印',
              currentComponent: {
                name: 'InfoBox',
                template: InfoBox,
                outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
                inputs: inputs
              }
            }
          })
        }
        _open(o.href)
      },
      getCoursesRecord () {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.courseApiPath, '/course/learn/count', null, r => {
            resolve(r.data)
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/learnrecord.vue